queryNamesAndQueryStrings